
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...brandguide]",
      function () {
        return require("private-next-pages/[...brandguide].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...brandguide]"])
      });
    }
  